import { getInboxV2SenderProfiles } from "../../../api/inbox-v2";

import type { InboxV2SenderProfileRefreshReason } from "../../types";
import {
  mapSenderProfileDto,
  mapSenderProfilePlatform,
  mapSenderProfilePlatformToApi,
} from "./data-source-helpers";

export interface InboxV2SenderProfileIdentity {
  accountId: string;
  platform: string;
  platformId: string;
  postId?: string;
  messagePlatformId?: string;
}

interface InboxV2GetSenderProfilesInput {
  identities: InboxV2SenderProfileIdentity[];
  refreshReason?: InboxV2SenderProfileRefreshReason;
}

export async function getInboxV2SenderProfilesApi(
  input: InboxV2GetSenderProfilesInput
) {
  const response = await getInboxV2SenderProfiles({
    ...input,
    identities: input.identities.map((identity) => ({
      ...identity,
      platform: mapSenderProfilePlatformToApi(identity.platform),
    })),
  });

  return response.items.map((item) => ({
    identity: {
      accountId: item.identity.accountId,
      platform: mapSenderProfilePlatform(item.identity.platform)!,
      platformId: item.identity.platformId,
      postId: item.identity.postId,
      messagePlatformId: item.identity.messagePlatformId,
    },
    profile: mapSenderProfileDto(item.profile),
  }));
}

export async function getInboxV2SenderProfile(input: {
  identity: InboxV2SenderProfileIdentity;
  refreshReason?: InboxV2SenderProfileRefreshReason;
}) {
  const profiles = await getInboxV2SenderProfilesApi({
    identities: [input.identity],
    refreshReason: input.refreshReason,
  });
  const firstItem = profiles[0];

  if (!firstItem) {
    throw new Error("Profile refresh returned no items");
  }

  return firstItem.profile;
}
